const stripe = Stripe("pk_test_xJNOSLhqbq9O63S6TajlCZ1t00kz2FZAvE");
import { getFunctions, httpsCallable } from "firebase/functions";
const functions = getFunctions();
const getSessionStatus = httpsCallable(functions, "getSessionStatus");

initialize();

async function initialize() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const sessionId = urlParams.get('session_id');

  console.log("URL param sessionId:", sessionId);

  getSessionStatus({ "sessionId": sessionId }).then((session) => { 
    console.log("session:", session.data.status);

    if (session.data.status == 'open') {
      window.replace('https://rhs-payments.web.app/stripe-checkout.html')
    } else if (session.data.status == 'complete') {

      console.log("session complete");

      document.getElementById('success').classList.remove('hidden');
      // document.getElementById('customer-email').textContent = session.customer_email
    }

  });


}